import React from "react";
import { Global, css } from "@emotion/react";

const exclusiveStyles = css`
  :root {
    --exclusive-navy-950: #07111f;
    --exclusive-navy-900: #0a1728;
    --exclusive-navy-850: #0d1d31;
    --exclusive-slate-700: #334155;
    --exclusive-slate-500: #64748b;
    --exclusive-slate-300: #cbd5e1;
    --exclusive-surface: rgba(255, 255, 255, 0.92);
    --exclusive-line: rgba(148, 163, 184, 0.2);
    --exclusive-glow: color-mix(in srgb, var(--primaryColor, #065183) 28%, transparent);
    --exclusive-shadow: 0 18px 46px rgba(15, 23, 42, 0.08);
    --exclusive-shadow-hover: 0 22px 60px rgba(15, 23, 42, 0.13);
  }

  body {
    background:
      radial-gradient(circle at 94% 4%, var(--exclusive-glow), transparent 25%),
      radial-gradient(circle at 18% 96%, rgba(59, 130, 246, 0.07), transparent 28%),
      #f3f6fb;
  }

  .logged-in-layout {
    position: relative;
    background: transparent !important;
  }

  .logged-in-layout::before {
    position: fixed;
    inset: 0;
    z-index: -1;
    content: "";
    pointer-events: none;
    opacity: 0.3;
    background-image:
      linear-gradient(rgba(148, 163, 184, 0.08) 1px, transparent 1px),
      linear-gradient(90deg, rgba(148, 163, 184, 0.08) 1px, transparent 1px);
    background-size: 34px 34px;
    mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), transparent 72%);
  }

  /* Sidebar: assinatura visual exclusiva */
  .logged-in-layout .MuiDrawer-paper {
    color: #dbe7f5 !important;
    background:
      radial-gradient(circle at 15% 6%, var(--exclusive-glow), transparent 24%),
      linear-gradient(180deg, var(--exclusive-navy-850) 0%, var(--exclusive-navy-950) 100%) !important;
    border-right: 1px solid rgba(148, 163, 184, 0.13) !important;
    box-shadow: 12px 0 42px rgba(2, 6, 23, 0.17) !important;
  }

  .logged-in-layout .MuiDrawer-paper::after {
    position: absolute;
    top: 0;
    right: 0;
    width: 1px;
    height: 100%;
    content: "";
    background: linear-gradient(to bottom, var(--primaryColor, #39ace7), transparent 34%);
    opacity: 0.7;
  }

  .logged-in-layout .MuiDrawer-paper > div:first-of-type {
    min-height: 72px;
    background: rgba(255, 255, 255, 0.035) !important;
    border-bottom: 1px solid rgba(148, 163, 184, 0.13) !important;
    backdrop-filter: blur(14px);
  }

  .logged-in-layout .MuiDrawer-paper .MuiList-root {
    padding: 12px 7px 18px;
  }

  .logged-in-layout .MuiDrawer-paper .MuiListItem-root {
    position: relative;
    min-height: 44px;
    margin: 3px 0;
    border-radius: 11px;
    color: #b7c6da;
    border: 1px solid transparent;
  }

  .logged-in-layout .MuiDrawer-paper .MuiListItem-root:hover {
    color: #fff;
    background: rgba(255, 255, 255, 0.065) !important;
    border-color: rgba(148, 163, 184, 0.12);
  }

  .logged-in-layout .MuiDrawer-paper .MuiListItem-root[class*="activeItem"] {
    color: #fff !important;
    background: linear-gradient(90deg, color-mix(in srgb, var(--primaryColor, #39ace7) 24%, transparent), rgba(255,255,255,.045)) !important;
    border-color: color-mix(in srgb, var(--primaryColor, #39ace7) 32%, transparent) !important;
    box-shadow: inset 3px 0 0 var(--primaryColor, #39ace7), 0 8px 20px rgba(2, 6, 23, .14);
  }

  .logged-in-layout .MuiDrawer-paper .MuiListItem-root[class*="activeItem"]::after {
    position: absolute;
    top: 50%;
    right: 9px;
    width: 5px;
    height: 5px;
    content: "";
    border-radius: 50%;
    background: #7dd3fc;
    box-shadow: 0 0 0 4px rgba(125, 211, 252, .1), 0 0 12px rgba(125, 211, 252, .8);
    transform: translateY(-50%);
  }

  .logged-in-layout .MuiDrawer-paper .MuiListItem-root .MuiTypography-root {
    color: inherit;
  }

  .logged-in-layout .MuiDrawer-paper .MuiAvatar-root {
    color: #bdd0e7;
    background: rgba(255, 255, 255, 0.075);
    border: 1px solid rgba(148, 163, 184, 0.12);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05);
  }

  .logged-in-layout .MuiDrawer-paper .MuiAvatar-root.active,
  .logged-in-layout .MuiDrawer-paper .MuiListItem-root:hover .MuiAvatar-root {
    color: #fff;
    background: var(--primaryColor, #065183);
    border-color: rgba(255, 255, 255, 0.18);
    box-shadow: 0 8px 24px var(--exclusive-glow);
  }

  .logged-in-layout .MuiDrawer-paper .MuiListSubheader-root {
    color: #71839b !important;
    background: transparent !important;
    font-size: 0.67rem;
    font-weight: 800;
    letter-spacing: 0.13em;
    text-transform: uppercase;
  }

  .logged-in-layout .MuiDrawer-paper .MuiCollapse-container {
    margin: 3px 0 8px 13px;
    padding-left: 5px;
    border-left: 1px solid rgba(148, 163, 184, .14);
  }

  .logged-in-layout .MuiDrawer-paper .MuiListItemText-primary {
    letter-spacing: .005em;
  }

  .logged-in-layout .MuiDrawer-paper ::-webkit-scrollbar {
    width: 5px;
  }

  .logged-in-layout .MuiDrawer-paper ::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background: rgba(148, 163, 184, .24);
  }

  .logged-in-layout .MuiDrawer-paper .MuiDivider-root {
    background-color: rgba(148, 163, 184, 0.13);
  }

  /* Topbar glass com acabamento executivo */
  .logged-in-layout .MuiAppBar-root {
    background: rgba(7, 17, 31, 0.9) !important;
    border-bottom: 1px solid rgba(148, 163, 184, 0.15) !important;
    box-shadow: 0 12px 36px rgba(2, 6, 23, 0.16) !important;
    backdrop-filter: blur(18px) saturate(145%);
  }

  .logged-in-layout .MuiAppBar-root::after {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 1px;
    content: "";
    background: linear-gradient(90deg, transparent, var(--primaryColor, #39ace7), transparent);
    opacity: 0.75;
  }

  .logged-in-layout .MuiAppBar-root .MuiToolbar-root {
    min-height: 58px;
    background: transparent !important;
    box-shadow: none !important;
  }

  .logged-in-layout .MuiAppBar-root .MuiIconButton-root {
    color: #dbe7f5;
    background: rgba(255, 255, 255, 0.035);
    border: 1px solid transparent;
  }

  .logged-in-layout .MuiAppBar-root .MuiIconButton-root:hover {
    color: #fff;
    background: rgba(255, 255, 255, 0.09);
    border-color: rgba(255, 255, 255, 0.09);
  }

  /* Área útil e superfícies */
  .logged-in-layout > main {
    background:
      linear-gradient(145deg, rgba(255, 255, 255, 0.36), transparent 38%),
      transparent !important;
  }

  .logged-in-layout > main::before {
    position: fixed;
    top: 84px;
    right: 4vw;
    width: 260px;
    height: 260px;
    content: "";
    pointer-events: none;
    background: radial-gradient(circle, var(--exclusive-glow), transparent 68%);
    filter: blur(22px);
    opacity: 0.22;
  }

  .logged-in-layout > main > *:not(:first-child) {
    animation: exclusive-enter 320ms cubic-bezier(0.22, 1, 0.36, 1);
  }

  @keyframes exclusive-enter {
    from {
      opacity: 0;
      transform: translateY(5px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .MuiPaper-rounded,
  .MuiCard-root,
  .MuiTableContainer-root {
    border-color: var(--exclusive-line) !important;
    box-shadow: var(--exclusive-shadow) !important;
  }

  .logged-in-layout main .MuiPaper-rounded:not(.MuiMenu-paper):not(.MuiPopover-paper):not(.MuiDialog-paper) {
    border: 1px solid var(--exclusive-line);
    background-color: var(--exclusive-surface);
    backdrop-filter: blur(14px) saturate(125%);
  }

  .logged-in-layout main .MuiPaper-elevation1 {
    transition: transform 220ms cubic-bezier(0.22, 1, 0.36, 1),
      border-color 220ms ease, box-shadow 220ms ease;
  }

  .logged-in-layout main .MuiPaper-elevation1:hover {
    border-color: color-mix(in srgb, var(--primaryColor, #065183) 28%, var(--exclusive-line)) !important;
    box-shadow: var(--exclusive-shadow-hover) !important;
  }

  .MuiCard-root {
    position: relative;
    overflow: hidden;
  }

  .MuiCard-root::before {
    position: absolute;
    top: 0;
    left: 18px;
    width: 52px;
    height: 2px;
    content: "";
    background: var(--primaryColor, #065183);
    border-radius: 0 0 999px 999px;
    box-shadow: 0 2px 14px var(--exclusive-glow);
  }

  .MuiButton-containedPrimary {
    position: relative;
    overflow: hidden;
    background: linear-gradient(135deg, var(--primaryColor, #065183), color-mix(in srgb, var(--primaryColor, #065183) 78%, #111827)) !important;
  }

  .MuiButton-containedPrimary::after {
    position: absolute;
    top: -80%;
    left: -45%;
    width: 35%;
    height: 260%;
    content: "";
    pointer-events: none;
    background: rgba(255, 255, 255, 0.16);
    transform: rotate(24deg);
    transition: left 420ms ease;
  }

  .MuiButton-containedPrimary:hover::after {
    left: 120%;
  }

  .MuiButton-containedPrimary:hover {
    box-shadow: 0 12px 28px var(--exclusive-glow) !important;
  }

  .MuiInputBase-root,
  .MuiAutocomplete-inputRoot {
    backdrop-filter: blur(8px);
  }

  .MuiTableRow-hover:hover .MuiTableCell-root {
    color: var(--ui-text);
  }

  .MuiTableCell-head:first-child,
  .MuiTableCell-body:first-child {
    padding-left: 20px;
  }

  /* Atendimento como console operacional premium */
  .logged-in-layout [class*="contactsWrapper"],
  .logged-in-layout [class*="messagesWrapper"] {
    border-color: rgba(148, 163, 184, 0.21) !important;
  }

  .logged-in-layout [class*="messagesList"] {
    background-blend-mode: soft-light;
  }

  .logged-in-layout [class*="messageLeft"],
  .logged-in-layout [class*="messageRight"] {
    backdrop-filter: blur(8px);
  }

  /* Dark mode */
  html[data-theme="dark"] {
    --exclusive-surface: rgba(15, 23, 42, 0.92);
    --exclusive-line: rgba(148, 163, 184, 0.14);
    --exclusive-shadow: 0 18px 48px rgba(0, 0, 0, 0.25);
    --exclusive-shadow-hover: 0 24px 66px rgba(0, 0, 0, 0.38);
  }

  html[data-theme="dark"] body {
    background:
      radial-gradient(circle at 94% 4%, var(--exclusive-glow), transparent 25%),
      radial-gradient(circle at 15% 96%, rgba(14, 165, 233, 0.08), transparent 28%),
      #07111f;
  }

  html[data-theme="dark"] .logged-in-layout::before {
    opacity: 0.13;
  }

  html[data-theme="dark"] .logged-in-layout > main {
    background: linear-gradient(145deg, rgba(30, 41, 59, 0.18), transparent 42%) !important;
  }

  @media (max-width: 959.95px) {
    .logged-in-layout .MuiAppBar-root .MuiToolbar-root {
      min-height: 54px;
    }

    .logged-in-layout::before {
      display: none;
    }

    .logged-in-layout > main::before {
      display: none;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .logged-in-layout > main > *:not(:first-child) {
      animation: none;
    }
  }
`;

const ExclusiveExperience = () => <Global styles={exclusiveStyles} />;

export default ExclusiveExperience;
